module.exports = __webpack_public_path__ + "img/logo.c4a0bfe1.png";